import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

// Protect routes that require authentication
const ProtectedRoute = ({ children, requireSubscription = false }) => {
  const { user, isSubscribed, loading } = useAuth();

  if (loading) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        minHeight: '60vh' 
      }}>
        <div className="loading"></div>
      </div>
    );
  }

  // Not logged in - redirect to home with login prompt
  if (!user) {
    return <Navigate to="/?login=true" replace />;
  }

  // Logged in but subscription required and user not subscribed
  if (requireSubscription && !isSubscribed) {
    return <Navigate to="/subscribe" replace />;
  }

  // All checks passed - show protected content
  return children;
};

export default ProtectedRoute;


